export const COLOR_THEME_STORAGE_KEY = "color-theme"

export const colorThemeOptions = [
  "classic",
  "corporate",
  "midnight",
  "emerald",
  "readability",
  "facebook",
  "twitter",
  "chatgpt",
  "claude",
] as const

export type ColorTheme = (typeof colorThemeOptions)[number]

const colorThemeSet = new Set<string>(colorThemeOptions)

export function resolveColorTheme(theme: string | null | undefined): ColorTheme {
  if (theme && colorThemeSet.has(theme)) {
    return theme as ColorTheme
  }
  return "classic"
}
